import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { loadModules } from "esri-loader";
import { BehaviorSubject, Subject, of } from "rxjs";
import { tap } from "rxjs/operators";

import { GISConfig } from "../models/gis-config.model";



@Injectable()
export class GisTokenService {
    config: GISConfig;
    public _pending: boolean = false;
    public _lockObs: Subject<any> = new Subject();
    userToken = new BehaviorSubject<string>("");
    userToken$ = this.userToken.asObservable();
    updateUserToken(data: string) {
        if (this.userToken.getValue() !== data) {
            this.userToken.next(data);
        }
    }


    userTokenExpire = new BehaviorSubject<number>(0);
    userTokenExpire$ = this.userTokenExpire.asObservable();

    updateuserTokenExpire(data: number) {
        if (this.userTokenExpire.getValue() !== data) {
            this.userTokenExpire.next(data);
        }
    }

    constructor(
        public readonly http: HttpClient
    ) {
        this.config = window["GIS.Conf"] as GISConfig;
        this.getToken().then(() => {
            console.log("GIS Token received and registered");
        });
    }

    async registerToken(token: any): Promise<any> {
        try {
            const [IdentityManager] = await loadModules(["esri/identity/IdentityManager"]);
            const identityInfo = {
                "serverInfos": [
                    {
                        "server": this.config.serverEndPoint,
                        "tokenServiceUrl": this.config.generateTokenEndpoint,
                        "shortLivedTokenValidity": 60,
                        "currentVersion": 10.5,
                        "hasServer": true
                    }
                ],
                "oAuthInfos": [],
                "credentials": [
                    {
                        "userId": this.config.tokenUsername,
                        "server": this.config.serverEndPoint,
                        "token": token.token,
                        "expires": token.expires,
                        "validity": 600,
                        "ssl": false,
                        "scope": "server",
                        "resources": [this.config.restServicesUrl]
                    }
                ]
            };
            IdentityManager.initialize(identityInfo);
            
            return of(IdentityManager.registerToken({
                "server": this.config.restServicesUrl,
                "userId": this.config.tokenUsername,
                "token": token.token,
                "expires": token.expires,
                "ssl": false
            })).toPromise();
        } catch (error) { console.error(error); }
    }

    async getToken(): Promise<any> {
        if (this.userToken.getValue() && this.userToken.getValue() !== "")
            return this.userToken.getValue();

        if (this._pending)
            return this._lockObs.asObservable().toPromise();

        this._pending = true;
        var error;
        try {
            console.log("Retrieving GIS Token");
            const [IdentityManager, esriConfig] = await loadModules([
                "esri/identity/IdentityManager",
                "esri/config"
            ]);
            esriConfig.apiKey = this.config.routingServicesApiKey;
            // Generate and retrieve Token
            const options = {
                method: "POST",
                path: this.config.generateTokenEndpoint,
                headers: { "Content-Type": "application/x-www-form-urlencoded" }
            };

            return this.http.post<any>(`api/gis/proxy-post?${this.config.generateTokenEndpoint}`, "", options).pipe(tap((postResponse: any) => {
                this.updateUserToken((postResponse as any).token);
                this.updateuserTokenExpire((postResponse as any).expires);
                console.log("GIS Token received. Registering");

                // Register Token with Server
                const identityInfo = {
                    "serverInfos": [
                        {
                            "server": this.config.serverEndPoint,
                            "tokenServiceUrl": this.config.generateTokenEndpoint,
                            "shortLivedTokenValidity": 60,
                            "currentVersion": 10.8,
                            "hasServer": true
                        }
                    ],
                    "oAuthInfos": [],
                    "credentials": [
                        {
                            "userId": this.config.tokenUsername,
                            "server": this.config.serverEndPoint,
                            "token": this.userToken.getValue(),
                            "expires": this.userTokenExpire.getValue(),
                            "validity": 600,
                            "ssl": false,
                            "scope": "server",
                            "resources": [
                                this.config.restServicesUrl
                            ]
                        }
                    ]
                };

                IdentityManager.initialize(identityInfo);
                console.log("GIS Token Registered");
             
                IdentityManager.registerToken({
                    'server': this.config.restServicesUrl,
                    'userId': this.config.tokenUsername,
                    'token': this.userToken.getValue(),
                    'expires': this.userTokenExpire.getValue(),
                    'ssl': false
                });
                this._pending = false;
                this._lockObs.next((postResponse as any).token); 
                this._lockObs.complete();
            })).toPromise();
        } catch (error) {
            console.log(`We have an error: ${error}`);
        }
    }
}